//
//  index.js
//  Tulip Web Modules SDK
//
//  Export file for I18n directory
//  © 2017 Tulip.
//


// - External Dependencies

/// Uses the Internationalization Extensions framework.
/// The export from this plugin is the default instance, created but not yet initialized.
/// https://www.i18next.com
import i18next from 'i18next';

// - Internal Dependencies

/// The I18n class from this directory.
import I18n from './I18n';

/// The 'parent' DOM representation.
/// Note that this is the SDK/Dom, not the SDK/I18n/Dom.
import GlobalDom from '../Dom';

// - Exports

/// Creates a new instance of the I18n class with a new instance of the translation framework.
/// Note: Use this only when the default export is insufficient for you.
export const createInstance = () => new I18n(i18next.createInstance(), GlobalDom);

/// The shared, default instance of the I18n class.
const instance = new I18n(i18next, GlobalDom);

export const translate = ::instance.translate;
export const getLanguage = () => instance.language;
export const Dom = instance.Dom;

export default instance;



// WEBPACK FOOTER //
// ./src/i18n/index.js